const config = {
  key: {
    admin: "___managed_medic_admin",
    token:"managedmedics_access_admin",
    refreshToken: "managedmedics_refresh_admin",
  },
};

export default config;
